import { setIsUsing3S } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
export default mutator(setIsUsing3S, function (actionMessage) {
    getStore().isUsing3S = actionMessage.isUsing3S;
});
//# sourceMappingURL=setIsUsing3SMutator.js.map